import {AdvancedMarker, InfoWindow, Map, Pin} from '@vis.gl/react-google-maps';
import clsx from 'clsx';
import React, {useMemo, useState} from 'react';

import {CompetitorLocationT, ListingSearchResultT} from '../types/competitive-analysis.types';

interface CompetitorMapPropsT {
  selectedListing: ListingSearchResultT | null;
  competitors: CompetitorLocationT[];
}

const mapContainerStyle = {
  width: '100%',
  height: '400px',

  borderRadius: '8px',
  overflow: 'hidden',
};

export function CompetitorMap({selectedListing, competitors}: CompetitorMapPropsT) {
  const [hoveredMarkerId, setHoveredMarkerId] = useState<string | null>(null);

  const center = useMemo(
    () => ({
      lat: selectedListing?.latitude || 0,
      lng: selectedListing?.longitude || 0,
    }),
    [selectedListing]
  );

  if (!selectedListing) {
    return null;
  }

  return (
    <div className="relative">
      {/* competitors color guide */}
      <div className="absolute left-2 top-2 z-10 rounded-sm bg-primary p-2 text-white">
        <div className="flex items-center gap-2">
          <div className="h-2.5 w-2.5 rounded-full bg-green" />
          <div className="text-xs">Delivery</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-2.5 w-2.5 rounded-full bg-red" />
          <div className="text-xs">Pickup</div>
        </div>
      </div>

      <Map
        mapId={'4b2726f9f4a6fadb'}
        style={mapContainerStyle}
        defaultZoom={11}
        defaultCenter={center}
        gestureHandling={'greedy'}
        disableDefaultUI={true}
        backgroundColor="#17263c"
      >
        {/* Selected Listing */}
        <AdvancedMarker
          position={center}
          onMouseEnter={() => setHoveredMarkerId('selected')}
          onMouseLeave={() => setHoveredMarkerId(null)}
        >
          <Pin background={'#3B82F6'} borderColor={'white'} glyphColor={'white'} scale={1.4} />
        </AdvancedMarker>
        {hoveredMarkerId === 'selected' && (
          <InfoWindow position={center} pixelOffset={[0, -40]} className="rounded-md bg-primary p-4" headerDisabled>
            <div className="text-sm font-medium text-white">{selectedListing.name}</div>
          </InfoWindow>
        )}

        {/* Competitors */}
        {competitors.map(competitor => (
          <React.Fragment key={competitor.id}>
            <AdvancedMarker
              position={{lat: competitor.latitude, lng: competitor.longitude}}
              onMouseEnter={() => setHoveredMarkerId(competitor.id)}
              onMouseLeave={() => setHoveredMarkerId(null)}
              draggable={false}
            >
              <div
                className={clsx(
                  'h-2.5 w-2.5 rounded-full border border-white shadow-sm',
                  competitor.isDelivery ? 'bg-green' : 'bg-red'
                )}
                style={{
                  transform: 'translate(-50%, -50%)',
                  position: 'absolute',
                }}
              />
            </AdvancedMarker>
            {hoveredMarkerId === competitor.id && (
              <InfoWindow
                position={{lat: competitor.latitude, lng: competitor.longitude}}
                pixelOffset={[0, -8]}
                className="rounded-md bg-[#24222a] p-4"
                headerDisabled
              >
                <div className="text-sm font-medium text-white">{competitor.name}</div>
              </InfoWindow>
            )}
          </React.Fragment>
        ))}
      </Map>
    </div>
  );
}
